/* ==========================================================================
   CLYDE CLONE — cb-pages.js
   Cart quantity updates and collection sorting.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Cart — change/remove a line without a full page reload
     --------------------------------------------------------------------- */
  function initCart() {
    var root = document.querySelector('[data-cb-cart]');
    if (!root || root.dataset.cbReady === '1') return;
    root.dataset.cbReady = '1';

    var busy = false;

    function setBusy(state) {
      busy = state;
      root.classList.toggle('is-busy', state);
    }

    function changeLine(line, quantity) {
      if (busy) return;
      setBusy(true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // The markup depends on Liquid (money format, discounts, properties),
          // so re-render from the server rather than patching the DOM here.
          window.location.reload();
        })
        .catch(function () {
          setBusy(false);
        });
    }

    root.querySelectorAll('[data-cb-line]').forEach(function (row) {
      var line = row.dataset.cbLine;
      var input = row.querySelector('[data-cb-line-input]');

      row.querySelectorAll('[data-cb-line-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!input) return;
          var next = parseInt(input.value, 10) + parseInt(btn.dataset.cbLineQty, 10);
          next = Math.max(0, next);
          input.value = next;
          changeLine(line, next);
        });
      });

      if (input) {
        input.addEventListener('change', function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          changeLine(line, v);
        });
      }

      var remove = row.querySelector('[data-cb-line-remove]');
      if (remove) {
        remove.addEventListener('click', function () { changeLine(line, 0); });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Collection sort — submit on change, no separate button
     --------------------------------------------------------------------- */
  function initSort() {
    document.querySelectorAll('[data-cb-sort]').forEach(function (form) {
      if (form.dataset.cbReady === '1') return;
      form.dataset.cbReady = '1';

      var select = form.querySelector('select');
      if (!select) return;

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location = url.toString();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Collection filters
     --------------------------------------------------------------------- */
  function initFacets() {
    var root = document.querySelector('[data-cb-coll]');
    if (!root || root.dataset.cbFacetsReady === '1') return;
    root.dataset.cbFacetsReady = '1';

    var panel = root.querySelector('[data-cb-facets]');
    var overlay = root.querySelector('[data-cb-facets-overlay]');
    var form = root.querySelector('[data-cb-facets-form]');

    /* --- Drawer on mobile --- */
    function openPanel() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) { overlay.hidden = false; overlay.classList.add('is-open'); }
      document.body.style.overflow = 'hidden';
    }
    function closePanel() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        window.setTimeout(function () { overlay.hidden = true; }, 250);
      }
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-cb-filter-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (panel && panel.classList.contains('is-open')) closePanel();
        else openPanel();
      });
    });
    root.querySelectorAll('[data-cb-filter-close]').forEach(function (b) {
      b.addEventListener('click', closePanel);
    });
    if (overlay) overlay.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closePanel();
    });

    /* --- Apply filters ---
       Empty inputs are dropped so the URL stays readable, and `page` is
       cleared: filtered results rarely have the page you were last on. */
    function apply() {
      if (!form) return;
      var params = new URLSearchParams();

      form.querySelectorAll('input, select').forEach(function (el) {
        if (el.disabled || !el.name) return;
        if (el.type === 'checkbox' && !el.checked) return;
        if (el.value === '' || el.value === null) return;
        params.append(el.name, el.value);
      });

      var base = window.location.pathname;
      var qs = params.toString();
      window.location = qs ? base + '?' + qs : base;
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });

      form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', apply);
      });

      // Price fields: wait for the person to finish typing.
      var priceTimer = null;
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.addEventListener('input', function () {
          window.clearTimeout(priceTimer);
          priceTimer = window.setTimeout(apply, 700);
        });
        input.addEventListener('change', function () {
          window.clearTimeout(priceTimer);
          apply();
        });
      });
    }

    /* --- Grid / list view --- */
    var grid = root.querySelector('[data-cb-grid]');
    var viewBtns = [].slice.call(root.querySelectorAll('[data-cb-view]'));

    function setView(mode) {
      if (grid) grid.classList.toggle('cb-grid--list', mode === 'list');
      viewBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.cbView === mode);
      });
      try { window.localStorage.setItem('cb-view', mode); } catch (e) { /* private mode */ }
    }

    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.cbView); });
    });

    if (viewBtns.length) {
      var saved = null;
      try { saved = window.localStorage.getItem('cb-view'); } catch (e) { saved = null; }
      if (saved) setView(saved);
    }
  }

  /* ---------------------------------------------------------------------
     Quick add from a product card (single-variant products only)
     --------------------------------------------------------------------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-cb-quick-add]').forEach(function (btn) {
      if (btn.dataset.cbReady === '1') return;
      btn.dataset.cbReady = '1';

      btn.addEventListener('click', function () {
        var label = btn.querySelector('[data-cb-quick-label]');
        var original = label ? label.textContent : '';

        btn.disabled = true;
        if (label) label.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: btn.dataset.cbQuickAdd, quantity: 1 }]
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetch('/cart.js');
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (label) label.textContent = 'Added';
            window.setTimeout(function () {
              if (label) label.textContent = original;
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            if (label) label.textContent = 'Try again';
            window.setTimeout(function () {
              if (label) label.textContent = original;
              btn.disabled = false;
            }, 1600);
          });
      });
    });
  }

  /* The count bubble is only rendered when the cart is not empty, so the
     first add has to create it rather than just update it. */
  function updateCartCount(count) {
    var bubble = document.querySelector('.cb-header__cart-count');
    if (bubble) {
      bubble.textContent = count;
      return;
    }
    var cart = document.querySelector('.cb-header__cart');
    if (!cart) return;
    var span = document.createElement('span');
    span.className = 'cb-header__cart-count';
    span.textContent = count;
    cart.appendChild(span);
  }

  function boot() {
    initCart();
    initSort();
    initFacets();
    initQuickAdd();
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
